import * as React from 'react';
import styled from 'styled-components';

import IViewProps from '../../IViewProps';
import CardWithHeader from '../CardWithHeader';
import ErrorMessage from '../ErrorMessage';

interface IProps extends IViewProps {
  errorMessage: string;
}

function UnstyledErrorScreen(props: IProps) {
  return (
    <CardWithHeader
      title="Fehler"
      className={props.className}
      onGoBack={props.onGoBack}
    >
      <section>
        <p>Tut uns leid, das hat leider nicht geklappt 🤭</p>
        <p>Versuch’s ein bisschen später nochmal.</p>
        <ErrorMessage>{props.errorMessage}</ErrorMessage>
      </section>
    </CardWithHeader>
  );
}

const ErrorScreen = styled(UnstyledErrorScreen)`
  > section {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 1rem;
  }
`;

export default ErrorScreen;



// WEBPACK FOOTER //
// ./src/components/ErrorScreen/ErrorScreen.tsx